import type { GlobalCalendarLocale, OwaDate } from 'owa-datetime';
import { localizedFormat, localizedFormatter } from './localizedFormatter';

export const getDayFormat: (dateFormat: string, timeFormat: string) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormat called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormat(/d{1,2}/);

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getDayFormat);
export default defaultExport;
